import React, { useState } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
import { Section } from './Shared';
import { faqs } from '../data/pack';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const reduceMotion = useReducedMotion();
  return <Section className="max-w-3xl" data-id="element-47" data-mp="1cgb7tbzjseem">
      <div className="mb-10 text-center" data-id="element-48" data-mp="2a1ysizmn58ab">
        <h2 className="font-display text-2xl font-bold text-brand-ink md:text-3xl" data-id="element-49" data-mp="2a0xf4oi5k9pf">
          LO QUE MÁS NOS PREGUNTAN
        </h2>
      </div>
      <div className="space-y-3" data-id="element-50" data-mp="2042kwhswwvgy">
        {faqs.map((faq, index) => {
        const isOpen = index === openIndex;
        return <article key={faq.q} className="glass-panel overflow-hidden rounded-2xl" data-id="element-51" data-mp="1v3y38og9pup5" data-mpi={index}>
              <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-6 px-5 py-5 text-left text-sm font-semibold text-brand-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-[-4px] focus-visible:outline-brand-teal md:px-6 md:text-base" data-id="element-52" data-mp="oq74z6u6oioo">
                <span data-id="element-53" data-mp="1fodm45kaowmn">{faq.q}</span>
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-brand-goldDark transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} data-id="element-54" data-mp="1fnc7jr42ls06" />
              </button>
              <AnimatePresence initial={false} data-id="element-55" data-mp="16piecp1lreh8">
                {isOpen && <motion.div initial={reduceMotion ? false : {
              opacity: 0,
              height: 0
            }} animate={{
              opacity: 1,
              height: 'auto'
            }} exit={reduceMotion ? undefined : {
              opacity: 0,
              height: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} data-id="element-56" data-mp="s044zgy10x1u">
                    <p className="border-t border-brand-violet/25 bg-brand-deep/40 px-5 py-5 text-sm leading-relaxed text-brand-text md:px-6 md:text-base" data-id="element-57" data-mp="38kpywprzaj4t">
                      {faq.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </article>;
      })}
      </div>
    </Section>;
}